import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import SearchIcon from 'mdi-react/SearchIcon';
import CloseIcon from 'mdi-react/CloseIcon';
import { useBasicAuth } from '../../../shared/components/auth/withBasicAuth';
import classNames from 'classnames';

export class TopbarSearch extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired
  };

  constructor() {
    super();
    this.state = { 
      inputOpen: false,
      value: ''
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  onInputOpen = (e) => {
    e.preventDefault();
    this.setState(prevState => ({ inputOpen: !prevState.inputOpen }));
  };

  handleChange(event) {
    this.setState({value: event.target.value});
  }

  handleSubmit(event) {
    let proccess = this.state.value.replace("/","-");
    useBasicAuth.redirectSearch(proccess);
    event.preventDefault();
  }

  render() {
    const { t } = this.props;
    const { inputOpen } = this.state;

    const searchClass = classNames({
      'topbar__search-field': true,
      'topbar__search-field--open': inputOpen,
    });

    return (
      <form className="topbar__search" onSubmit={this.handleSubmit}>
        <input placeholder={t('searchBar.searchProcess') + "..."} 
          className={searchClass} style={{maxWidth: "220px"}}
          value={this.state.value} onChange={this.handleChange}/>
        <button className="topbar__btn topbar__search-btn" type="button" onClick={this.onInputOpen}>
          {inputOpen ? <CloseIcon /> : <SearchIcon />}
        </button>
        {/* {inputOpen && <button className="topbar__back" type="button" onClick={this.onInputOpen} />} */}
      </form>
    );
  }
}

export default withTranslation('common')(TopbarSearch);